import React from 'react'
import { motion } from 'framer-motion'

const navLinkItems = [
  'home',
  'about',
  'work',
  'skills',
  'testimonial',
  'contact',
]

const NavigationDots = ({ active }) => {
  return (
    <motion.div
      whileInView={{
        opacity: [0, 1],
        transition: {
          duration: 1,
          ease: 'easeInOut',
        },
      }}
      transition={{ duration: 1, delayChildren: 0.5 }}
      className='app__navigation'
    >
      {navLinkItems.map((item, index) => (
        <a
          href={`#${item}`}
          key={`${item} ${index}`}
          className='app__navigation-dot'
          style={active === item ? { background: '#313BAC' } : {}}
        />
      ))}
    </motion.div>
  )
}

export default NavigationDots
